/**
 * @file AudienceBadge.js
 * @description Reusable audience badge with icon for audience display.
 */

import React from 'react';

function AudienceBadge({ label, showIcon = true }) {
    if (!label) {
        return null;
    }

    return (
        <span
            className={`badge-base badge-audience${showIcon ? '' : ' badge-audience-no-icon'}`}
        >
            {showIcon && (
                <span className="badge-audience-icon" aria-hidden="true">
                    <svg
                        width="16"
                        height="13"
                        viewBox="0 0 28 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <ellipse
                            cx="5.5"
                            cy="7"
                            rx="2"
                            ry="2.5"
                            stroke="currentColor"
                            strokeWidth="1.5"
                        />
                        <path
                            d="M0.5 18 C0.5 13 3 11 5.5 11 C8 11 10.5 13 10.5 18"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            fill="none"
                        />
                        <ellipse
                            cx="22.5"
                            cy="7"
                            rx="2"
                            ry="2.5"
                            stroke="currentColor"
                            strokeWidth="1.5"
                        />
                        <path
                            d="M17.5 18 C17.5 13 20 11 22.5 11 C25 11 27.5 13 27.5 18"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            fill="none"
                        />
                        <ellipse
                            cx="14"
                            cy="5"
                            rx="2.75"
                            ry="3.5"
                            fill="currentColor"
                        />
                        <path
                            d="M6.5 18 C6.5 12.5 9.75 10 14 10 C18.25 10 21.5 12.5 21.5 18 Z"
                            fill="currentColor"
                        />
                        <line
                            x1="0.5"
                            y1="18"
                            x2="27.5"
                            y2="18"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </span>
            )}
            <span>{label}</span>
        </span>
    );
}

export default AudienceBadge;
